var sidr = require( '../../node_modules/sidr/dist/jquery.sidr.js' );

// jQuery
jQuery( document ).ready( function ( $ ) {

    var nav = responsiveNav( "#primary" );
    nav.destroy();

    // Mobile nav
    $( ".sidr-nav-toggle" ).sidr( {
        name: 'mobile-nav',
        side: 'left',
        source: '#primary',
        speed: 150,
        rename: false,
        displace: false
    } );

    $( window ).resize( function () {
        var wi = $( window ).width();
        if ( wi > 959 ) {
            $.sidr( 'close', 'mobile-nav' );
        }
    } );

    // Team members slider
    $( '#team-members .wrapper' ).unslick();
    $( '#team-members .wrapper' ).slick( {
        infinite: true,
        slide: '.person',
        arrows: true,
        appendArrows: '#team-members-nav',
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        responsive: [
            {
                breakpoint: '960',
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: false
                }
            }
        ]
    } );
} );